import { ReactElement } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { IStatusMobileUser } from '~/services/api/mobileUsers/types';
import styles from './Item.module.scss';
import PhoneFlagText from '~/ui/components/inputs/PhoneFlagText';

interface IProps {
  mobileUser: IStatusMobileUser;
}

const Item = ({ mobileUser }: IProps): ReactElement => (
  <TableRow>
    <TableCell>
      <PhoneFlagText value={mobileUser.phone} />
    </TableCell>
    <TableCell>{mobileUser.roleName}</TableCell>
    <TableCell className={styles.cell}>{mobileUser.programs.map(x => x.name).join(', ')}</TableCell>
  </TableRow>
);

export default Item;
